import React, { useEffect } from 'react';

import { ChildTooltip } from '../../Elements/ChildTooltip';

import { ControlTowerQuery } from '../../../modules/control-tower/api';

import { Button } from '../../ui/button';
import { DoorClosedLocked } from 'lucide-react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../ui/dialog';
import { useCutoffTimes } from '../../../modules/control-tower/use-control-tower';
import { Skeleton } from '../../ui/skeleton';
import { CutoffData } from './CutoffData';
import { Input } from '../../ui/input';

const Loader = () => {
  return (
    <>
      <div className="flex items-center space-x-4">
        <Skeleton className="h-12 w-12 rounded-full" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-[600px]" />
          <Skeleton className="h-4 w-4/5" />
        </div>
      </div>
      <div className="flex items-center space-x-4">
        <Skeleton className="h-12 w-12 rounded-full" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-[600px]" />
          <Skeleton className="h-4 w-4/5" />
        </div>
      </div>
      <div className="flex items-center space-x-4">
        <Skeleton className="h-12 w-12 rounded-full" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-[600px]" />
          <Skeleton className="h-4 w-4/5" />
        </div>
      </div>
    </>
  );
};

export const CutoffDialog = ({ query }: { query: ControlTowerQuery }) => {
  const { cutoffData, error, loading, fetchIt, setSearch } = useCutoffTimes();

  useEffect(() => {
    fetchIt(query);
  }, [query]);

  return (
    <Dialog>
      <ChildTooltip title="View Thresholds" asChild>
        <DialogTrigger>
          <Button size="icon" variant="secondary">
            <DoorClosedLocked />
          </Button>
        </DialogTrigger>
      </ChildTooltip>
      <DialogContent className="min-w-[80vw] max-h-[500px]">
        <DialogHeader>
          <DialogTitle>Defined cutoff times for tollgates</DialogTitle>
          <DialogDescription>
            <ul>
              <li>• Times indicate hours and minutes in your timezone</li>
              <li>
                • The days indicate the number of days until the delivery date, if the scan happens before the cutoff
              </li>
            </ul>
          </DialogDescription>
          <div className="flex justify-end">
            <Input className="w-1/2" type="search" placeholder="Search" onChange={(e) => setSearch(e.target.value)} />
          </div>
        </DialogHeader>
        {loading && <Loader />}
        {error && <div>Something went wrong fetching the data...</div>}
        {cutoffData && <CutoffData data={cutoffData} />}
        <DialogFooter>
          <DialogClose asChild>
            <Button>Close</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
